@if (vm$ | async; as vm) {
    <dff-sidenav-menu #DffSidenavMenu [items]="vm.menuItems" (itemClick)="itemClick.emit($event)" id="eforsyning-sidenav-menu" role="list" id="sidenav-menu">
        @if (vm.visInstallationMenuItem) {
            <li class="aktuel-installation">
                <div class="aktuel-installation__grid">
                    @if (vm.vaelgInstallationHref) {
                        <a
                            class="aktuel-installation__info"
                            [href]="vm.vaelgInstallationHref"
                            (click)="DffSidenavMenu.onItemClick($event, vm.vaelgInstallationHref)"
                        >
                            <div class="adresse">{{ vm.aktuelInstallation?.adresse }}</div>
                            <div class="maaler">
                                @if (vm.aktuelInstallation?.maalerNr) {
                                    <small>Måler: {{ vm.aktuelInstallation.maalerNr }}</small>
                                }
                                @if (!vm.aktuelInstallation?.maalerNr) {
                                    <small>Status: Passiv</small>
                                }
                            </div>
                        </a>
                    } @else {
                        <div class="aktuel-installation__info">
                            <div class="adresse">{{ vm.aktuelInstallation?.adresse }}</div>
                            <div class="maaler">
                                @if (vm.aktuelInstallation?.maalerNr) {
                                    <small>Måler: {{ vm.aktuelInstallation.maalerNr }}</small>
                                }
                                @if (!vm.aktuelInstallation?.maalerNr) {
                                    <small>Status: Passiv</small>
                                }
                            </div>
                        </div>
                    }
                    @if (showNotificationTrigger$ | async) {
                        <eforsyning-notification-dialog-trigger class="aktuel-installation__notifications"></eforsyning-notification-dialog-trigger>
                    }
                    @if (vm.vaelgInstallationHref) {
                        <a
                            class="skift"
                            [href]="vm.vaelgInstallationHref"
                            (click)="DffSidenavMenu.onItemClick($event, vm.vaelgInstallationHref)"
                        >SKIFT...</a>
                    }
                </div>
            </li>
        }
    </dff-sidenav-menu>
} @else {
    <div class="spinner-container">
        <mat-spinner class="mat-spinner"></mat-spinner>
    </div>
}
<ng-template #spinner>
    <div class="spinner-container">
        <mat-spinner class="mat-spinner"></mat-spinner>
    </div>
</ng-template>
